

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {IOnOffHandlers} from "bonomo/dist";
import {IPermissionMap} from "@/store/modules/permissionsModule";
import {Prop, VModel, Watch} from "vue-property-decorator";

const permissionsModule = namespace("permissionsModule");

  @Component({})
  export default class PermissionMapDialog extends Vue {

    @VModel()
    protected show!: boolean;
    @Prop()
    protected action!: string;
    @Prop()
    private showOnlyPermission!: string;

    @permissionsModule.Getter('permissionTargets')
    private permissionTargets!: string[];
    @permissionsModule.Getter('actionTargets')
    private actionTargets!: string[];
    @permissionsModule.Getter('permissionMaps')
    private permissionMaps!: IPermissionMap[];

    @Watch('action')
    onActionChanged() {
      this.updateValueMap();
    }

    private valueMap: any = {};
    private loading: boolean = false;

    private subscribes: IOnOffHandlers = {};

    get permissionCodes() {
      const showOnlyPermission = this.showOnlyPermission;
      return Object.keys(this.permissionTargets)
          .filter((each) => (!showOnlyPermission || (showOnlyPermission == each)));
    }

    created() {
      this.subscribes = this.$ons({
        'login.OK': this.onClose,
        'backend.call.OK.permissionMapsLoaded': this.onPermissionMapsLoaded,
        'backend.call.KO.permissionMapsLoaded': this.onPermissionMapsLoaded,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected hasDescription(i: number) {
      const key = 'settings.permissions.permissions.' + i + '.description';
      return this.$t(key).toString() !== key;
    }

    protected onClose() {
      if (this.loading) {
        return;
      }
      this.show = false;
    }

    private onMapAlways(eachPermissionCode: number) {
      this.setMap(eachPermissionCode, 1);
    }

    private onMapDelete(eachPermissionCode: number) {
      this.setMap(eachPermissionCode, 0);
    }

    private onMapDev(eachPermissionCode: number) {
      this.setMap(eachPermissionCode, 3);
    }

    protected onMapSameChannel(eachPermissionCode: number) {
      this.setMap(eachPermissionCode, 2);
    }

    private onPermissionMapsLoaded() {
      this.loading = false;
      this.updateValueMap();
    }

    private setMap(permissionCode: number, mapCode: number) {
      this.loading = true;
      this.$store.dispatch('permissionsModule/setMap', {
        action: this.action,
        permission: permissionCode,
        code: mapCode,
      });
    }

    protected updateValueMap() {
      Object.keys(this.valueMap).forEach(eachPermission => {
        this.valueMap[eachPermission] = null;
      });
      this.permissionMaps
          .filter((eachMap: IPermissionMap) => eachMap.action == this.action)
          .forEach((eachMap: IPermissionMap) => {
            this.valueMap[eachMap.permission] = eachMap.code;
          });
    }

  }
